import React from 'react';
import { Toast } from 'react-bootstrap';
import classNames from 'classnames';

import styles from './ErrorMsg.module.scss';

type Props = {
  isShow: boolean;
  error: any;
  closeHandler: () => void;
};

const ErrorMsg: React.FC<Props> = ({ isShow, error, closeHandler }) => {
  if (!isShow) return null;

  return (
    <div className={classNames('p-3', styles.wrapper)}>
      <Toast show={isShow} onClose={closeHandler} delay={16000} className={styles.errorBody}>
        <Toast.Header>
          <strong className="text-danger">Помилка!</strong>
        </Toast.Header>
        <Toast.Body>{error}</Toast.Body>
      </Toast>
    </div>
  );
};

export default ErrorMsg;
